// FORM BUILDER ACTIONS:
export const SET_PAGE_CONTENT = "SET_PAGE_CONTENT";
export const UPDATE_BREADCRUMBS = "UPDATE_BREADCRUMBS";
export const UPDATE_PROFILE_PERMISSION = "UPDATE_PROFILE_PERMISSION";
export const SET_ACCESS_LOGIC  = "SET_ACCESS_LOGIC"
export const SET_WINDOW_MENU_VISIBILITY = "SET_WINDOW_MENU_VISIBILITY";
export const SET_FIELD_ACCESS = "SET_FIELD_ACCESS";
export const SET_ACCESS_USER_LOGIC = "SET_ACCESS_USER_LOGIC";
export const SET_ACCESS_PAGES_LOGIC = "SET_ACCESS_PAGES_LOGIC";
export const SET_BUTTON_ACCESS = "SET_BUTTON_ACCESS";
export const UPDATE_EMAIL_ACCESS_FIELD = "UPDATE_EMAIL_ACCESS_FIELD";
